// extracted by mini-css-extract-plugin
module.exports = {"device":"_O5p-OeU","video":"_FpDa9so","videoWrap":"_2xXfGHi","videoIframe":"_Ue7XbC3"};